import React from 'react';
import classNames from 'classnames';
import {Discount, Money} from '../../PulsoidClient';
import {ActionWithProgress} from '../buttons';
import {LoaderWrapper} from '../Loader/Loader';
import css from './PricingBlock.module.css';
import {formatMoney} from '../../utils/moneyUtils';

export type PricingBlockProps = {
  title: string;
  description?: string;
  price: Money;
  discount?: Discount;
  buttonLabel: string;
  onBuyClick: () => void;

  loading?: boolean;
};

export const PricingBlock = (props: PricingBlockProps) => {
  return (
    <div
      className={classNames(css.root, {
        [css.rootLoading]: !!props.loading,
        [css.rootDiscounted]: !!props.discount,
      })}
    >
      <LoaderWrapper
        loading={props.loading || false}
        color="#ffffff"
        description="Looking for the best deal"
      >
        {!props.loading ? (
          <>
            {props.discount && <div className={css.discountLabel}>deal</div>}

            <h3 className={css.title}>{props.title}</h3>
            <div className={css.price}>
              {props.discount && (
                <span className={css.discounted}>
                  &nbsp;{formatMoney(props.price)}&nbsp;
                </span>
              )}
              <span className={css.priceValue}>
                {formatMoney(
                  props.discount ? props.discount?.price : props.price
                )}
              </span>
              {props.description && (
                <div className={css.description}>{props.description}</div>
              )}
            </div>
            <ActionWithProgress
              className={css.button}
              onClick={props.onBuyClick}
              outline={!props.discount}
              square
            >
              {props.buttonLabel}
            </ActionWithProgress>
          </>
        ) : null}
      </LoaderWrapper>
    </div>
  );
};
